import styled from 'styled-components';

export const FilterButton = styled.div`
    button {
        border: 1.5px dashed var(--color-border, #d1d5db);
        border-radius: 9999px;
        background-image: none;
    }

    button:hover {
        border-color: var(--color-border-hover, #9ca3af);
    }
`;
